import React from "react";
import cn from "classnames";
import type { IIconProps } from "../types";
import { svgPathsMap } from "../constants";
import styles from "./Icon.module.scss";

export const Icon: React.FC<IIconProps> = ({
  name,
  path = "icons",
  className,
  onClick,
  onError,
  title,
  ...imgProps
}) => {
  const svgPath = svgPathsMap.get(path)[name];

  return (
    <div
      className={cn(styles.wrapper, className)}
      onClick={onClick}
      title={title}
    >
      <img src={svgPath} {...imgProps} alt={title || name} onError={onError} />
    </div>
  );
};
